<template>
  <div class="popup-overlay ">
    <div class="sensor-popup-overlay animated zoomIn">
      <div class='popup-title flex'>
        <span>{{ $t('sensors') }}</span>
        <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="sensorPopup()" />
      </div>
      <div class="sensors-body">
        <div>
          <br>
          <div class="sensor-popup">
            <div class="flex sensor-row" v-for="machine in fit20.sensorsMachines">
              <div class="sec1">{{ machine.name }}</div>
              <div class="sec2">
                <input type="text" class="form-control" v-model="machine.ipAddress" />
              </div>
              <div class="sec3">
                <img v-if="machine.connected" :src="fit20.storageBaseUrl + '/machine-setting/' + 'sensor-green.svg'"
                  width="40" />
                <img v-if="!machine.connected" :src="fit20.storageBaseUrl + '/machine-setting/' + 'sensor-red.svg'"
                  width="40" />
              </div>
              <div class="sec4">
                <img v-if="!machine.connecting" width="40px"
                  :src="fit20.storageBaseUrl + '/static/icons/refresh-light-gray.svg'"
                  @click="connectToSensor(machine)" />
                <img v-if="machine.connecting" class="connecting" width="40px"
                  :src="fit20.storageBaseUrl + '/static/icons/refresh-gray.svg'" />
              </div>
            </div>
          </div>
          <div class="btn-container">
            <img class="new-session-btn" width="60px" :src="fit20.storageBaseUrl + '/static/icons/save.png'"
              @click="saveSensorSetting()">
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formattedDateTime } from "../actions/global.js";
export default {
  name: 'Sensors',
  props: ["fit20", "sensorPopup"],
  data() {
    return {
      showMenu: false,
      machines: [],
      isChanged: false,
    };
  },
  methods: {
    connectToSensor: async function (machine) {
      let machineY = this.fit20.sensorsMachines.find(machineX => machineX.id == machine.id);
      if (machineY) {
        if (machine.ipAddress) {
          this.$set(machine, 'connecting', true);
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 7000);
          try {
            let response = await fetch(this.fit20.hostProtocol + machine.ipAddress + ':' + this.fit20.MSA_port + '/identify', {
              signal: controller.signal,
              method: 'POST',
              body: JSON.stringify({ machineId: machine.id, machineName: machine.name.includes('duction') ? 'Adduction / abduction' : machine.name }),
            });
            const data = await response.json();
            this.$set(machine, 'connecting', false);
            if (data.machineId) {
              this.$set(machine, 'connected', true);
            }
            clearTimeout(timeoutId);
          } catch (err) {
            if (err.name === 'AbortError') {
              console.log('Request timed out after 5 seconds');
              this.$set(machine, 'connecting', false);
              console.log({ err });
              this.fit20.errors.push("Error in connectToSensor in Sensor.js " + formattedDateTime());
              this.fit20.errors.push(JSON.stringify({
                message: err.message,
                stack: err.stack,
                name: err.name,
              }) + " " + formattedDateTime());
            } else {
              this.$set(machine, 'connecting', false);
              console.log({ err });
              this.fit20.errors.push("Error in connectToSensor in Sensor.js " + formattedDateTime());
              this.fit20.errors.push(JSON.stringify({
                message: err.message,
                stack: err.stack,
                name: err.name,
              }) + " " + formattedDateTime());
            }
          }
        }
      }
    },

    saveSensorSetting: function () {
      // let machines = [];
      // this.fit20.sensorsMachines.forEach(machine => {
      //   machine.ipAddress = machine.ipAddress.trim();
      //   machines.push({ id: machine.id, ipAddress: machine.ipAddress });

      // });
      // this.fit20.studio.machines = machines;
      // Update the studio machines, keeping the non-matching items
      this.fit20.studio.machines.forEach((studioMachine) => {
        const updatedMachine = this.fit20.sensorsMachines.find(m => m.id == studioMachine.id);
        if (updatedMachine) {
          // Update the existing machine's ipAddress if a match is found
          studioMachine.ipAddress = updatedMachine.ipAddress;
        }
      });
      // handel the ip address for the new leg press
      const oldLegPress = this.fit20.sensorsMachines.find(m => m.id == "1001");
      const newLegPress = this.fit20.studio.machines.find(m => m.id == this.fit20.newLegPress);
      if (oldLegPress && newLegPress) {
        newLegPress.ipAddress = oldLegPress.ipAddress;
      }


      fetch(this.fit20.baseUrl + '/api/studios/ipAddress/' + this.fit20.user.email + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.fit20.studio),
      });
      this.sensorPopup();
    }
  },

};
</script>
<style>
.sensors-body {
  background-color: white;
  z-index: 1000;
  padding: 15px 15px 0px 15px;
  /* border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px; */
}

.sensor-popup .sec1 {
  min-width: 110px;
}

.sensor-popup .sec2,
.sensor-popup .sec3,
.sensor-popup .sec4 {
  margin-left: 15px;
}

.sensor-popup .sec4 .connecting {
  animation: rotate360 4s linear infinite;
}

.sensor-popup .flex {
  justify-content: center;
  justify-items: center;
  align-items: center;
}

.sensor-popup input {
  border-radius: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px;

}

.sensor-popup input:focus {
  border: solid 1px var(--fit20-lighter-blue);
}

.sensor-row {
  height: 45px;
}

@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
